import { CalendarOutlined, LoadingOutlined } from "@ant-design/icons";
import { Image } from "antd";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getAuthRole } from "../../../../../utils/auth";
import exportPdf from "../../../../../assets/export-pdf.svg";
import SharedWelcomeBar from "../../../../components/WelcomeBar";
import {
  DatePopupWrap,
  DateRangePill,
  ExportIconButton,
} from "../../../../components/WelcomeBar/style";
import type { DateRange } from "../../types";

dayjs.extend(customParseFormat);

interface WelcomeBarProps {
  name: string;
  dateRange: DateRange;
  onDateRangeChange: (value: DateRange) => void;
  onExportPdf: () => void;
  pdfExporting?: boolean;
}

export default function WelcomeBar({
  name,
  dateRange,
  onDateRangeChange,
  onExportPdf,
  pdfExporting,
}: WelcomeBarProps) {
  const showExports = getAuthRole() === "admin";

  return (
    <SharedWelcomeBar
      name={name}
      subtitle="These are the latest updates for the last 7 days"
      controls={
        <>
          <DateRangePill
            value={dateRange}
            onChange={(values) =>
              onDateRangeChange((values as DateRange) ?? null)
            }
            format="DD/MM/YYYY"
            allowClear
            allowEmpty={[true, true]}
            placeholder={["Start date", "End date"]}
            disabledDate={(current: Dayjs) => current.isAfter(dayjs(), "day")}
            prefix={<CalendarOutlined />}
            panelRender={(panel: React.ReactNode) => (
              <DatePopupWrap>{panel}</DatePopupWrap>
            )}
          />
          {showExports && (
            <ExportIconButton
              $mobileOrder={4}
              onClick={pdfExporting ? undefined : onExportPdf}
              aria-label="Export PDF"
            >
              {pdfExporting ? (
                <LoadingOutlined spin />
              ) : (
                <Image src={exportPdf} alt="Export PDF" preview={false} />
              )}
            </ExportIconButton>
          )}
        </>
      }
    />
  );
}
